import React from 'react';
import { cn } from '@bridebook/aura';
import { PolymorphicComponentProps } from '@bridebook/aura/src/lib/type-helpers';
import { cva } from 'class-variance-authority';
import { keyBy } from 'lodash';

const displayTextVariantsArray = [
  'display-xl',
  'display-2xl',
  'display-3xl',
  'display-4xl',
  'display-5xl',
  'display-6xl',
  'display-7xl',
] as const;
type DisplayTextVariant = (typeof displayTextVariantsArray)[number];
const displayTextVariantsObject = keyBy<DisplayTextVariant>(displayTextVariantsArray);

// m-0 is to reset the maring that comes from our legacy normalizer
const displayTextVariants = cva('m-0 text-space', {
  variants: {
    variant: displayTextVariantsObject,
  },
  defaultVariants: {
    variant: 'display-xl',
  },
});

type DisplayTextProps = {
  variant?: DisplayTextVariant;
};
const defaultComponent = 'p';
export const DisplayText = <C extends React.ElementType = typeof defaultComponent>({
  as,
  children,
  variant,
  className,
  ...props
}: PolymorphicComponentProps<C, DisplayTextProps>) => {
  const Component = as || defaultComponent;

  return (
    <Component className={cn(displayTextVariants({ variant }), className)} {...props}>
      {children}
    </Component>
  );
};
